<template>
  <v-row class="px-4">
    <v-col v-for="(tool, id) in filteredTools" :key="id" cols="2">
      <BaseTooltip bottom>
        <template #activator="{on, attrs}">
          <v-btn
            v-bind="attrs"
            height="34" width="34"
            :color="tool.id === value ? $vuetify.theme.themes.dark.elements : defaultColor"
            :style="{
              color:
                (tool.id === value)
                  ? $vuetify.theme.themes.dark.elementsText
                  : 'black'
            }"
            x-small elevation="0" :disabled="disabled || activeMapInteractionWidget === 'StandardMenu'"
            v-on="on"
            @click="
              tool.id === value
                ? $emit('input', null)
                : $emit('input', tool.id)
            ">
            <v-icon> {{ tool.icon }}</v-icon>
          </v-btn>
        </template>
        {{ tool.title }}
      </BaseTooltip>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'DrawToolPicker',
  props: {
    value: { type: String, default () { return null } },
    disabled: { type: Boolean, default () { return false } },
    disabledTools: { type: Array, default () { return [] } },
  },
  computed: {
    filteredTools () {
      return this.allTools.filter(tool => {
        if (!this.is3DView && tool.is3DTool) {
          return false
        }
        return !this.disabledTools.includes(tool.id)
      })
    },
    allTools () {
      return [
        {
          title: this.labels.point,
          id: 'point',
          icon: 'mdi-circle-small',
        },
        {
          title: this.labels.line,
          id: 'line',
          icon: 'mdi-chart-timeline-variant',
        },
        {
          title: this.labels.freehandLine,
          id: 'freehandLine',
          icon: 'mdi-sine-wave',
        },
        {
          title: this.labels.polygon,
          id: 'polygon',
          icon: 'mdi-hexagon-outline',
        },
        {
          title: this.labels.freehandPolygon,
          id: 'freehandPolygon',
          icon: 'mdi-go-kart-track',
        },
        {
          title: this.labels.rectangle,
          id: 'rectangle',
          icon: 'mdi-border-all-variant',
        },
        {
          title: this.labels.circle,
          id: 'circle',
          icon: 'mdi-circle-outline',
        },
        {
          title: this.labels.text,
          id: 'text',
          icon: 'mdi-format-text',
        },
        {
          title: this.labels.distance3d,
          id: 'line3d',
          icon: 'mdi-vector-line',
          is3DTool: true,
        },
        {
          title: this.labels.area3d,
          id: 'area3d',
          icon: 'mdi-hexagon-outline',
          is3DTool: true,
        },

      ]
    },
    activeMapInteractionWidget () {
      return this.$store.getters.getActiveMapInteractionWidget
    },
    labels () {
      return this.getLabels(this.$store.getters.getLanguage).drawToolPicker
    },
    defaultColor () {
      return '#bfc8cf'
    },
    is3DView () {
      return this.$store.getters.getViewType === '3d'
    },
  },
}
</script>
